

import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { APP_RETIREMENT_URLS, APP_URLS, COUNTRY_FRANCE_ID } from '../../const/AppConst';
import { IAdresseSearchFeature, IContactType } from '../../context/model';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import MgpAddressFormAutoComplete from '../../elements/MgpAddressFormAutoComplete/MgpAddressFormAutoComplete';
import MgpFormSelect from '../../elements/MgpFormSelect/MgpFormSelect';
import { useFetchNomenclature } from '../../hooks/useFetchNomenclature';
import { useEffect } from 'react';
import useAppState from '../../context/AppContext';

type InfoAddressInputFormComponentProps = {
    register: UseFormRegister<any>;
    errors: any;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    globalSave: boolean;
    countryShow?: boolean;
    currentStep: string;
    hasLieudit?: boolean;
}

export type InfoAddressInputTemplateFormData = {
    address: string;
    postalCode: string;
    city: string;
    countryId: string;
    lieudit: string;
    additionalAddress : string;
    buildingName: string;
  }
  



export default function InfoAddressInputTemplate({register, setValue, errors, watch, globalSave, countryShow, currentStep, hasLieudit = true} : Readonly<InfoAddressInputFormComponentProps>) {
    const {
        state: { updatedProposition, proposition }
    } = useAppState();
    if(countryShow === undefined) {countryShow = true}
    const countryNomenclature = useFetchNomenclature("country", true);
    const isClient = proposition?.configuration?.byContactType === IContactType.CLIENT;

    useEffect(() => {
        if(countryNomenclature && updatedProposition?.countryId&& globalSave !==false) {
          setValue("countryId", updatedProposition.countryId);
        }
        
      }, [countryNomenclature]);
  
    function onAddressSelect(data:IAdresseSearchFeature) {
        setValue("address", data.properties.name);
        setValue("postalCode", data.properties.postcode);
        setValue("city", data.properties.city);
        countryShow
        && setValue("countryId", COUNTRY_FRANCE_ID);
    
    }
    

    return (      
        <div> 
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                        label="Complément du nom"
                        labelFontWeight='regular'
                        type="text"
                        id="additionalAddress"
                        maxLength={38}
                        readOnly={isClient}
                        value={isClient ? proposition?.contact?.additionalAddress : watch('additionalAddress')}
                        register={register}
                        errors={errors}
                    />       
                </div>  
            </div>  
                    
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                        label="Résidence et bâtiment"
                        labelFontWeight='regular'
                        type="text"
                        id="buildingName"
                        maxLength={38}
                        readOnly={isClient}
                        value={isClient ? proposition?.contact?.buildingName : watch('buildingName')}
                        register={register}
                        errors={errors}
                    /> 
                </div>   
            </div>


            <div className='form-row'>
                <div className="form-group mw-100 autocomplete">   
                    {
                        isClient 
                        ? <MgpFormInput 
                            label="Numéro et libellé de la voie"  
                            type="text"
                            register={register}
                            id="address"
                            maxLength={38}
                            labelFontWeight='regular'
                            readOnly={true}
                            value={proposition?.contact?.address}
                        />
                        : <MgpAddressFormAutoComplete 
                            label="Numéro et libellé de la voie"  
                            type="text"
                            register={register}
                            id="address"
                            maxLength={38}
                            labelFontWeight='regular'
                            errors={errors} onDataSelect={(data) => {onAddressSelect(data)}} 
                            required={true}
                        />
                    }      
                    
                </div> 
            </div>     

            {hasLieudit &&
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput 
                        label="Lieu-dit, Hameau, Commune, BP"
                        labelFontWeight='regular'
                        id="lieudit"
                        maxLength={38}
                        readOnly={isClient}
                        value={ isClient ? proposition?.contact?.lieudit : watch("lieudit")}
                        register={register}
                        errors={errors}
                    />  
                </div>   
            </div>
            }
    
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                        label="Code postal"
                        id="postalCode"
                        labelFontWeight='regular'
                        register={register} 
                        errors={errors}
                        readOnly={isClient}
                        value={isClient ? proposition?.contact?.postalCode : watch('postalCode')}
                        required={!isClient}
                    />
                </div>
            </div>
          
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                        label="Ville"
                        id="city"
                        labelFontWeight='regular'
                        register={register} 
                        errors={errors}
                        readOnly={isClient}
                        required={!isClient}
                        value={isClient ? proposition?.contact?.city : watch('city')}
                    />     
                </div>
            </div>
          {countryShow &&
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormSelect 
                        id="countryId" 
                        data={countryNomenclature.options} 
                        label="Pays" 
                        labelFontWeight='regular' 
                        register={register} 
                        errors={errors} 
                        required={!isClient}
                        disabled={isClient}
                        value={isClient ? proposition?.contact?.countryId : watch('countryId')}
                    />       
                </div>
            </div>    
            } 
            {(currentStep === APP_URLS.infoOldContractPage || currentStep === APP_RETIREMENT_URLS.infoOldContractPage) &&
            <div className="form-group mw-100 mt-sm">
                <p className='bg-menthe blanc p-xs flex va-center jc-start' style={{gap: "10px", flexWrap: "unset"}}>
                <i className='icon-info blanc '></i>
                <span style={{lineHeight: 1.5}}>
                    Merci de vérifier attentivement l'adresse postale de votre ancienne mutuelle.
                    Une adresse incorrecte ou incomplète pourrait retarder ou empêcher la résiliation de votre contrat.
                </span>
                </p>
            </div>  
            }
      </div>      
      
  )
}
